// context/OverlayToolContext.js
import React, { createContext, useContext, useRef, useCallback } from 'react';

const OverlayToolContext = createContext(null);

// Provider wraps the app; OverlayTool registers its inject handler here
export const OverlayToolProvider = ({ children }) => {
    const injectRef = useRef(null);

    // OverlayTool calls this to register its injection handler
    const registerInjectHandler = useCallback((handler) => {
        injectRef.current = handler;
    }, []);

    // ProductDetailModal calls this to send a product to the canvas
    const sendToOverlayTool = useCallback((payload) => {
        if (injectRef.current) {
            injectRef.current(payload);
        }
    }, []);

    return (
        <OverlayToolContext.Provider value={{ registerInjectHandler, sendToOverlayTool }}>
            {children}
        </OverlayToolContext.Provider>
    );
};

export const useOverlayTool = () => useContext(OverlayToolContext);
